export default {
    'North America': [
        {
            value: '0',
            text: 'www.ebay.com'
        },
        {
            value: '2',
            text: 'www.ebay.ca'
        },
        {
            value: '210',
            text: 'FRCA - www.ebay.ca'
        },
    ],
    'Europe': [
        {
            value: '3',
            text: 'www.ebay.co.uk'
        },
        {
            value: '16',
            text: 'www.ebay.at'
        },
        {
            value: '123',
            text: 'BENL - www.ebay.be'
        },
        {
            value: '23',
            text: 'BEFR - www.ebay.be'
        },
        {
            value: '71',
            text: 'www.ebay.fr'
        },
        {
            value: '77',
            text: 'www.ebay.de'
        },
        {
            value: '101',
            text: 'www.ebay.it'
        },
        {
            value: '146',
            text: 'www.ebay.nl'
        },
        {
            value: '186',
            text: 'www.ebay.es'
        },
        {
            value: '193',
            text: 'www.ebay.ch'
        },
        {
            value: '203',
            text: 'www.ebay.in'
        },
        {
            value: '205',
            text: 'www.ebay.ie'
        },
        {
            value: '212',
            text: 'www.ebay.pl'
        },
    ],
    'Asia': [
        {
            value: '201',
            text: 'www.ebay.com.hk'
        },
        {
            value: '207',
            text: 'www.ebay.com.my'
        },
        {
            value: '211',
            text: 'www.ebay.ph'
        },
        {
            value: '216',
            text: 'www.ebay.com.sg'
        },
    ],
    'Australia': [
        {
            value: '15',
            text: 'www.ebay.com.au'
        },
    ],
    'Other': [
        {
            value: '100',
            text: 'MOTORS - www.ebay.com'
        },
    ]
}



// WEBPACK FOOTER //
// ./src/assets/js/region-codes/ebay.js